import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";


const baseurl =
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:8000/api";

const handleError = (error) => {
    return error?.response?.data || {
        detail: error?.message || "Request failed.",
    };
};
const getToken = (getState) => {
  const token = getState()?.auth?.access_token || localStorage.getItem("access_token");

  return token;
};

export const fetchDashboardData = createAsyncThunk(
    'dashboard/fetchData',
    async (_, { getState }) => {
        try {
            const now = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            const localToday = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
            const response = await axios.get(`${baseurl}/dashboard/stats`, {
                params: { today: localToday },
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken(getState)}`,
                },
            });

            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
);
